theme.GallerySection = function (c) {
  this.c = c; this.init();
};
theme.GallerySection.prototype = {
  init() {
    this.c.querySelectorAll('.gallery__play-button').forEach(b => {
      const v = this.c.querySelector(`.gallery-video[data-section-id="${b.dataset.sectionId}"] video`);
      if (!v) return;
      const btn = b.cloneNode(true); b.replaceWith(btn);
      v.muted = true; v.playsInline = true; v.play().catch(()=>{});
      btn.onclick = e => {e.preventDefault(); v[v.paused?'play':'pause']().catch(()=>{});};
      v.onplay = () => this.update(btn,1);
      v.onpause = () => this.update(btn,0);
    });
  },
  update(b, p) {
    b.dataset.action = p?'pause':'play';
    b.querySelector('.gallery__play-icon').style.display = p?'none':'block';
    b.querySelector('.gallery__pause-icon').style.display = p?'block':'none';
  }
};

(function(){
  const init=()=>document.querySelectorAll('[data-section-type="gallery-section"]').forEach(c=>{
    if(!c.galleryInitialized){ new theme.GallerySection(c); c.galleryInitialized=1;}
  });
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
  document.addEventListener('shopify:section:load',e=>{
    const c=e.target.querySelector('[data-section-type="gallery-section"]');
    if(c&&!c.galleryInitialized){ new theme.GallerySection(c); c.galleryInitialized=1;}
  });
})();
